import { Component } from '@angular/core';

import type { GetInputs } from '@recruitee/common';
import { componentOutletConfigFactory } from '@recruitee/common';

import { TagComponent } from '../../../common/tag/tag.component';
import type { DataTableRow, TableCellFactory } from '../../data-table.types';
import { EMPTY_CELL } from '../text-cell.component';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  imports: [TagComponent],
  template: `
    @for (tag of tags; track tag) {
      <rt-tag [isHoverable]="isHoverable" [name]="tag" [disabled]="disabled" />
    }
  `,
  styleUrls: ['./tags-cell.component.less'],
  host: {
    '[class]': '"tags-list"',
  },
  inputs: TagsCellComponent.NgInputs,
})
export class TagsCellComponent {
  public static NgInputs = ['tags' as const, 'disabled' as const, 'isHoverable' as const];

  public tags: Array<TagComponent['name']>;
  public disabled?: TagComponent['disabled'];
  public isHoverable: TagComponent['isHoverable'] = true;
}

export const tagsCellFactory =
  <Key extends keyof Row, Row extends DataTableRow & Record<Key, string[]>>(
    key: Key,
    inputs: Omit<GetInputs<typeof TagsCellComponent>, 'tags'>,
  ): TableCellFactory<Row> =>
  ({ row }) => {
    if (!row[key]?.length) return EMPTY_CELL;

    return componentOutletConfigFactory(TagsCellComponent, {
      inputs: { tags: row[key], ...inputs },
    });
  };
